const translate = {
  from: {
    en: 'From',
    es: 'Desde',
    fr: 'De',
    de: 'Von',
    pt: 'De',
    pl: 'Od',
    nl: 'Van',
    el: 'Από',
    cs: 'Od',
    sv: 'Från',
    hu: 'Tól',
    da: 'Fra',
    fi: 'Alkaen',
    sk: 'Od',
    bg: 'От',
    hr: 'Od',
    lt: 'Nuo',
    lv: 'No',
    et: 'Alates',
    sl: 'Od',
    ga: 'Ó',
    mt: 'Minn',
    cy: 'O',
    ro: 'De la',
    it: 'Da',
    zh_cn: '从',
    hi: 'से',
    ar: 'من',
    bn: 'থেকে',
    ru: 'С',
    ja: 'から',
    tr: 'İtibaren',
    ko: '부터',
    vi: 'Từ',
    id: 'Dari',
    th: 'จาก',
    ms: 'Dari',
    ar_eg: 'من',
    uk: 'Від',
  },
  to: {
    en: 'To',
    es: 'Hasta',
    fr: 'À',
    de: 'Bis',
    pt: 'Até',
    pl: 'Do',
    nl: 'Tot',
    el: 'Έως',
    cs: 'Do',
    sv: 'Till',
    hu: 'Ig',
    da: 'Til',
    fi: 'Saakka',
    sk: 'Do',
    bg: 'До',
    hr: 'Do',
    lt: 'Iki',
    lv: 'Līdz',
    et: 'Kuni',
    sl: 'Do',
    ga: 'Go',
    mt: 'Sa',
    cy: 'Hyd',
    ro: 'Până la',
    it: 'A',
    zh_cn: '到',
    hi: 'तक',
    ar: 'إلى',
    bn: 'পর্যন্ত',
    ru: 'До',
    ja: 'まで',
    tr: 'Kadar',
    ko: '까지',
    vi: 'Đến',
    id: 'Ke',
    th: 'ถึง',
    ms: 'Ke',
    ar_eg: 'إلى',
    uk: 'До',
  },
}

export default translate
